import axios from "axios";
import { useSiteSettings } from '../context/SiteSettingsContext';
// 🔹 Axios Request Interceptor für alle API-Requests
import { jwtDecode } from "jwt-decode";

const rawAxios = axios.create(); // eigene Instanz ohne Interceptor
const logLevel = 0; // Hier kannst du den Log-Level setzen (0-3)

let isRefreshing = false;
let refreshPromise: Promise<string> | null = null;

axios.interceptors.request.use(
  
  async (config) => {
    
    const token = localStorage.getItem("token");
    if (logLevel >= 3) console.log("Access Token gefunden:", token);
    if (!token) return config;

    try {
      const decoded = (jwtDecode as unknown as (token: string) => { exp: number })(token);
      const now = Math.floor(Date.now() / 1000);
      if (logLevel >= 3) console.log("Token läuft ab in:", decoded.exp - now, "Sekunden");
      const refresh = localStorage.getItem("refreshToken");
      if (logLevel >= 3) console.log("Refresh Token:", refresh);
      if (decoded.exp - now < 1800) {
        if (logLevel >= 3) console.log("Token ist fast abgelaufen. Versuche zu refreshen...");

        if (!isRefreshing) {
          isRefreshing = true;
          const refresh = localStorage.getItem("refreshToken");

          if (!refresh) {
            if (logLevel >= 2) console.warn("Kein Refresh Token gefunden – Logout notwendig?");
            isRefreshing = false;
            return config;
          }

          refreshPromise = rawAxios.post("/auth/api/token/refresh/", { refresh })
            .then((res) => {
              const newToken = res.data.access;
              if (logLevel >= 3) console.log("Neuer Access Token erhalten:", newToken);
              localStorage.setItem("token", newToken);
              return newToken;
            })
            .catch((err) => {
              if (logLevel >= 1) console.error("Fehler beim Token-Refresh:", err);
              return token;
            })
            .finally(() => {
              isRefreshing = false;
            });
        }

        if (refreshPromise) {
          const newToken = await refreshPromise;
          config.headers.Authorization = `Bearer ${newToken}`;
        }
      } else {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (err) {
      if (logLevel >= 1) console.error("Fehler beim Überprüfen oder Erneuern des Tokens:", err);
    }

    return config;
  },
  
  (error) => {
    console.error("Interceptor-Fehler:", error);
    return Promise.reject(error);
  }
);

// Falls du später weitere Interceptors hinzufügen willst
export default axios;